
import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';

import { email } from './validator';

const VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => EmailValidatorDirective),
  multi: true
};

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[email][formControlName],[email][formControl],[email][ngModel]',
  providers: [ VALIDATOR ]
})
export class EmailValidatorDirective implements Validator {
  validate(c: AbstractControl): {[key: string]: any} {
    return email(c);
  }
}
